import { render, staticRenderFns } from "./DormantMemberIframe.vue?vue&type=template&id=4aba5df2&"
import script from "./DormantMemberIframe.vue?vue&type=script&lang=ts&"
export * from "./DormantMemberIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports